import { useEffect, useState } from 'react';
import { Privilege } from '../../api';
import useMe from './useMe';
import _ from 'underscore';

export function hasPrivilege(privileges: Array<Privilege> | undefined, needsOneOf: Array<Privilege>) {
  if (!privileges) return true;
  return _.intersection(privileges, needsOneOf).length > 0;
}

export default function usePrivileges() {
  const [privileges, setPrivileges] = useState<Array<Privilege>>();
  const { data } = useMe();

  // Remember the latest callback.
  useEffect(() => {
    if (data && data.me && data.me.roles) {
      setPrivileges(data.me.roles?.flatMap((role) => role?.privileges || []));
    }
  }, [data]);
  return privileges;
}
